import "./index.scss";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import store from "./store/store";
import { Provider } from "react-redux";
import { hydrateRoot, createRoot } from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';

try {
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
} catch (error) {
  console.error(error);
}

const theme = createTheme({
  primaryColor: 'violet',
  primaryShade: 6,
});

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <Provider store={store}>
      <MantineProvider theme={theme} defaultColorScheme="auto">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MantineProvider>
    </Provider>
  );
} else {
  const root = createRoot(rootElement); // Create a root.
  root.render(
    <Provider store={store}>
      <MantineProvider theme={theme} defaultColorScheme="auto">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MantineProvider>
    </Provider>
  );
}

